import chunk from 'lodash-es/chunk'

import { CALENDAR_GRID_DAY_COUNT } from '../CalendarGrid.constants'

export function getCalendarGridMonthWeeks(days) {
  return chunk(days, CALENDAR_GRID_DAY_COUNT)
}
